import { Injectable } from '@angular/core';
import { PatientDto } from 'src/app/shared/models/DTO/PatientDto';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  constructor(private httpRes: HttpRequestService) { }

  getPatients( pagination :string)
  {
      return this.httpRes.GetRequest(`Patients/GetPatients/${pagination}`);
  }

  getPatientsByName(name: string)
  {
      return this.httpRes.GetRequest(`Patients/GetByName/${name}`);
  }

  addPatient(patient: PatientDto)
  {
      return this.httpRes.postRequest("Patients/AddPatient" , patient);
  }

  getPatientById(userId : string){
    return this.httpRes.GetRequest(`Patients/GetById/${userId}`);
  }

  updatePatient(patient: PatientDto){
    return this.httpRes.postRequest("Patients/UpdatePatient" , patient);
  }
  SendEmail(mail)
  {
      return this.httpRes.postRequest("Patients/SendEmail" , mail);
  }
  ActivationPatient(id){
    return this.httpRes.postRequest("Patients/ActivationPatient/" + id,id);
  }

  EmailExist(Email:string, patientUserId : string){
    return this.httpRes.GetRequest(`Patients/EmailExist/${Email}/${patientUserId}`);
  }

  PhoneNumberExist(PhoneNumber:string, patientUserId : string){
    return this.httpRes.GetRequest(`Patients/PhoneNumberExist/${PhoneNumber}/${patientUserId}`);
  }

  IdCardNumberExist(IdCardNumber:string, patientUserId : string){
    return this.httpRes.GetRequest(`Patients/IdCardNumberExist/${IdCardNumber}/${patientUserId}`);
  }

  UpdatePatientStageDiagnosesStatus(patientUserId: string, DiagnosesStatus: number){
    return this.httpRes.GetRequest(`Patients/UpdatePatientStageDiagnosesStatus/${patientUserId}/${DiagnosesStatus}`);
  }

  GetPatientSubscriptionStages(patientUserId : number)
  {
    return this.httpRes.GetRequest(`SubscriptionStages/GetPatientSubscriptionStages/${patientUserId}`);
  }

}
